module.exports = __webpack_public_path__ + "static/media/bg1.b0a5abcc.jpg";